/**
 * Cursor Selector Component
 * 
 * Allows selection of cursor size (1x1, 3x1, 1x3, 2x3, 3x2)
 * Ported from cursor selection in main.mxml
 */

export class CursorSelector {
    constructor(containerElement, gridCanvas) {
        this.container = containerElement;
        this.gridCanvas = gridCanvas;
        this.currentMode = '1x1';
        
        this.render();
    }
    
    /**
     * Render the cursor selector
     */
    render() {
        const modes = [
            { id: '1x1', label: '1x1' },
            { id: '3x1', label: '3x1' },
            { id: '1x3', label: '1x3' },
            { id: '2x3', label: '2x3' },
            { id: '3x2', label: '3x2' }
        ];
        
        this.container.innerHTML = `
            <div class="cursor-selector">
                <h4>Cursor Size</h4>
                <div class="cursor-buttons">
                    ${modes.map(mode => `
                        <button 
                            class="cursor-btn ${this.currentMode === mode.id ? 'active' : ''}" 
                            data-mode="${mode.id}"
                            title="${mode.label}">
                            ${mode.label}
                        </button>
                    `).join('')}
                </div>
            </div>
        `;
        
        // Setup event listeners
        this.container.querySelectorAll('.cursor-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const mode = e.target.dataset.mode;
                this.setMode(mode);
            });
        });
    }
    
    /**
     * Set cursor mode
     */
    setMode(mode) {
        this.currentMode = mode;
        if (this.gridCanvas) {
            this.gridCanvas.setCursorMode(mode);
        }
        
        // Update UI
        this.container.querySelectorAll('.cursor-btn').forEach(btn => {
            btn.classList.toggle('active', btn.dataset.mode === mode);
        });
    }
    
    /**
     * Get current cursor mode
     */
    getMode() {
        return this.currentMode;
    }
}

